import React, {useCallback, useMemo} from 'react';
import {SelectGroup} from '@flixbus/honeycomb-react';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import {updateFilter} from '../../../store/slice';
import {ProductionCostEntryOrigin} from '../../../store/types';
import {CalculationOriginFilterOptions} from './CalculationOriginFilter.constants';

const CalculationOriginFilter: React.FC = () => {
  const origins = useAppSelector(
    ({calculatedEntries}) => calculatedEntries.filters.origins
  );

  const dispatch = useAppDispatch();

  const handleSelect = useCallback(
    (value: ProductionCostEntryOrigin[]) => {
      dispatch(
        updateFilter({
          field: 'origins',
          value
        })
      );
    },
    [dispatch]
  );

  const options = useMemo(() => {
    return CalculationOriginFilterOptions.map(option => ({
      ...option,
      defaultChecked: origins.includes(option.value),
      onClick: () => {
        const newSelection = origins.includes(option.value)
          ? origins.filter(item => item !== option.value)
          : [...origins, option.value];

        handleSelect(newSelection);
      }
    }));
  }, [handleSelect, origins]);

  return (
    <SelectGroup
      extraClasses="calculation-select-group"
      label="Calculation origin"
      options={options}
      multi
    />
  );
};

export default React.memo(CalculationOriginFilter);
